export function validateSearchTerm(searchTerm: string): boolean {
  if (!searchTerm) return false;

  // check trailing spaces
  // if(/\s+$/.test(searchTerm)) return false;

  // check search term only contains numbers
  if (/^[0-9]+$/.test(searchTerm)) return false;

  // check the search term only contains special char
  if (/^[^a-zA-Z0-9\s]+$/.test(searchTerm)) return false;

  if (/[a-zA-Z]+/.test(searchTerm) === false) return false;

  return true;
}

export function escapeQuerySpecialCharacters(value: string): string {
  // Step 1: Escape double-character operators
  value = value
    .replace(/\|\|/g, "\\||") // '||' ➝ \||
    .replace(/&&/g, "\\&&"); // '&&' ➝ \&&

  // Step 2: Replace **single** & (not part of &&) with %26
  value = value.replace(/(?<!&)&(?!&)/g, "%26");

  // Step 3: Escape individual special characters
  const specialChars = /[+\-!(){}\[\]^"~*?:\\/]/g;
  value = value.replace(specialChars, (char) => `\\${char}`);

  // Step 4: Escape space
  value = value.replace(/ /g, "\\ ");

  return value;
}

export function escapeQuerySpecialCharacter(value: string): string {
  value = value
    .replace(/\|\|/g, "\\||")
    .replace(/&&/g, "\\&&")
    .replace(/(?<!&)&(?!&)/g, "%26");

  const specialChars = /[+\-!(){}\[\]^"~?:\\/]/g;
  value = value.replace(specialChars, (char) => `\\${char}`);

  return value;
}

export const getValidCharacters = (searchTerm: string) =>
  searchTerm.replace(/[^a-zA-Z0-9]/g, "");
